export enum ItRegistryStatusEnum {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  ABSENT = 'ABSENT',
}
